import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Patient } from 'src/app/core/api/patient.service';
import { LayoutsService } from 'src/app/logged-in-navbar/clinic-setup-modal/layouts/layouts.service';
import { SymptomModes } from 'src/app/shared/symptoms/symptom.model';

export interface AssessmentSection {
  name: string;
  key: string;
  status: 'done' | 'skipped' | 'pending';
  isPreStep?: boolean;
  isFinal?: boolean;
}

@Component({
  selector: 'csi-assessment-sidebar',
  templateUrl: './assessment-sidebar.component.html',
  styleUrls: ['./assessment-sidebar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AssessmentSidebarComponent {
  @Input() patient: Patient;
  @Input() currentStep: number;
  @Input() assessmentMethodControl: FormControl;

  @Input() set sections(value: AssessmentSection[]) {
    this._sections = value || [];
    const completed = this._sections.filter(s => s.status === 'done' || s.status === 'skipped').length;
    this.completedCount = completed;
    this.isAllComplete = this._sections.length > 0 && completed === this._sections.length;
    this.progressPercent = this._sections.length === 0 ? 0 : Math.round((completed / this._sections.length) * 100);
  }

  get sections(): AssessmentSection[] {
    return this._sections;
  }

  private _sections: AssessmentSection[] = [];
  completedCount = 0;
  isAllComplete = false;
  progressPercent = 0;

  @Output() stepChange = new EventEmitter<number>();
  @Output() exitAssessment = new EventEmitter<void>();
  @Output() methodChange = new EventEmitter<SymptomModes>();
  @Output() editPatient = new EventEmitter<void>();

  constructor(public layoutsService: LayoutsService) {}

  getVisibleStepIndex(section: AssessmentSection): number {
    return this.sections.indexOf(section);
  }

  onStepClick(section: AssessmentSection): void {
    const idx = this.sections.indexOf(section);
    if (idx >= 0) {
      this.stepChange.emit(idx);
    }
  }

  onMethodSelected(method: SymptomModes): void {
    this.methodChange.emit(method);
  }

  noSort(): number {
    return 0;
  }
}
